var map = {
	"./chess/title.webp": 16443,
	"./egame/title.webp": 97221,
	"./fishing/title.webp": 25226,
	"./gaming/title.webp": 32660,
	"./lottery/title.webp": 65615,
	"./realbet/title.webp": 63738,
	"./sport/title.webp": 11110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36215;